var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    role: "img",
    "aria-label": "Flag of India",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "#FF9933"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 26.6667,
    width: 120,
    height: 26.6667,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 53.3333,
    width: 120,
    height: 26.6667,
    fill: "#138808"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,40)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 8.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.6,
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000088",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("line", {
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(15)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(30)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(45)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(60)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(75)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(90)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(105)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(120)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(135)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(150)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(165)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(180)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(195)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(210)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(225)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(240)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(255)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(270)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(285)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(300)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(315)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(330)",
    y1: 1.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    transform: "rotate(345)",
    y1: 1.6,
    y2: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.e01af1aa2f8b614377da813dece25a18.svg";
export { ForwardRef as ReactComponent };